<template>
  <!-- Main -->
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/shop-guide">ショップガイド</router-link></li>
        </ul>
      </div>
    </div>
    <div class="shop-guide">
      <ShopGuideList />
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";
import { metaData } from '@/utils/helper';

export default {
  name: "ShopGuide",
  components: {
    ShopGuideList: () => import("@/components/common/shop/ShopGuideList.vue"),
  },
  computed: {},
  created() {
    metaData(
      `ショップガイド | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのショップ一覧です。お探しのショップを検索することができます。',
      'HARUMIFLAGタウンポータル',
      'blog',
    )
  },
};
</script>